import { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
const NAV = [
    { to: "/", label: "Home", testid: "nav-home" },
    { to: "/about", label: "About Us", testid: "nav-about" },
    { to: "/programmes", label: "Programmes", testid: "nav-programmes" },
    { to: "/impact-hub", label: "Impact Hub", testid: "nav-impact-hub" },
    { to: "/media", label: "Media Centre", testid: "nav-media" },
    { to: "/gallery", label: "Gallery", testid: "nav-gallery" },
    { to: "/warren-park-connect", label: "Warren Park Connect", testid: "nav-wpc" },
    { to: "/get-involved", label: "Get Involved", testid: "nav-get-involved" },
    { to: "/contact", label: "Contact", testid: "nav-contact" },
];

export default function Header() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const loc = useLocation();

    useEffect(() => { setMobileOpen(false); }, [loc.pathname]);

    return (
        <div className="sticky top-0 z-50">
            <header
                className="w-full bg-white/95 backdrop-blur-md border-b border-[#eef0ee] py-3"
                data-testid="site-header"
            >
                <div className="gsf-container flex items-center gap-4">
                    {/* Brand — single logo, identical on load, scroll, sticky. */}
                    <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="header-brand-link">
                        <Logo variant="full" size={64} className="rounded-md" />
                    </Link>

                    <nav className="hidden lg:flex items-center gap-1 flex-1 justify-center" data-testid="primary-nav">
                        {NAV.map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                end={n.to === "/"}
                                data-testid={n.testid}
                                className={({ isActive }) =>
                                    `px-3 py-2 rounded-full text-sm font-medium transition-colors ${
                                        isActive
                                            ? "text-[color:var(--gsf-green-700)] bg-[color:var(--gsf-soft-green)]"
                                            : "text-[color:var(--gsf-charcoal)] hover:text-[color:var(--gsf-green-700)]"
                                    }`
                                }
                            >
                                {n.label}
                            </NavLink>
                        ))}
                    </nav>

                    <div className="ml-auto flex items-center gap-2">
                        <Link to="/donate" className="gsf-btn-gold text-sm !py-2.5 !px-5" data-testid="header-donate-btn">
                            Donate
                        </Link>
                        <button
                            onClick={() => setMobileOpen((v) => !v)}
                            className="lg:hidden p-2 rounded-lg hover:bg-[color:var(--gsf-soft-green)]"
                            aria-label="Menu"
                            data-testid="mobile-menu-toggle"
                        >
                            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
                        </button>
                    </div>
                </div>

                {mobileOpen && (
                    <div className="lg:hidden border-t border-[#eef0ee] bg-white" data-testid="mobile-menu">
                        <div className="gsf-container py-4 flex flex-col gap-1">
                            <div className="mb-3 flex justify-center py-4 bg-[color:var(--gsf-soft-green)] rounded-xl">
                                <Logo variant="full" size={96} />
                            </div>
                            {NAV.map((n) => (
                                <NavLink
                                    key={n.to}
                                    to={n.to}
                                    end={n.to === "/"}
                                    data-testid={`m-${n.testid}`}
                                    className={({ isActive }) =>
                                        `px-4 py-3 rounded-lg text-base font-medium ${
                                            isActive
                                                ? "bg-[color:var(--gsf-soft-green)] text-[color:var(--gsf-green-700)]"
                                                : "text-[color:var(--gsf-charcoal)]"
                                        }`
                                    }
                                >
                                    {n.label}
                                </NavLink>
                            ))}
                            <Link to="/donate" className="gsf-btn-gold mt-3 justify-center" data-testid="m-donate">
                                Donate
                            </Link>
                        </div>
                    </div>
                )}
            </header>
        </div>
    );
}
